import PropTypes from "prop-types";
export default function MilestoneProgressBar({ progress }) {
  const userProgress = (progress.AwardedCount / progress.AwardedAfterEvents) * 100;
  const userProgressString =
    userProgress > 100 ? "100%" : "" + userProgress + "%";

  return (
    <div className="flex justify-between items-center overflow-hidden">
      <div className="relative w-[160px] h-1">
        <div className={`w-[160px] h-1 bg-[#E3E3E3]`}></div>
        <div
          style={{
            width: userProgressString,
          }}
          className={`absolute top-0 left-0 h-full max-w-full ${
            userProgressString !== "100%" ? "bg-sportsYellow" : "bg-[#47B405]"
          }`}
          data-testid="progress-percent"
        ></div>
      </div>
      <div className="">
        <p
          className={`
                    ${
                      progress.AwardedCount >= progress.AwardedAfterEvents
                        ? "text-[#47B405]"
                        : "text-[#727272]"
                    }
                    text-[12px] leading-6 tracking-[2.4px] font-semibold
                `}
        >
          {progress.AwardedCount}
          {progress.AwardedAfterEvents !== 1 && <span>/{progress.AwardedAfterEvents}</span>}
        </p>
      </div>
    </div>
  );
}

MilestoneProgressBar.propTypes = {
  progress: PropTypes.shape({
    current: PropTypes.number.isRequired,
    steps: PropTypes.number.isRequired,
    singular: PropTypes.bool,
  }).isRequired,
};
